import React, {useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Header } from "../Header/Header";
import { MainMenu } from "../MainMenu/MainMenu";
import { ErrorFallback } from "../../components/ErrorFallback/ErrorFallback";
import "./PageLayout.scss";
import { activeUser, removeActiveUser } from "../../services/AuthService";
import { useTranslation } from "react-i18next";
import {useApplicationContext} from "../../application/ApplicationContext";

export interface PageLayoutProps {
  children?: React.ReactElement | React.ReactElement[];
}

export const PageLayout = (p: PageLayoutProps) => {
  const navigate = useNavigate();
  const {state, setMainMenu} = useApplicationContext()

  const { t } = useTranslation();

  return (
    <div className="rwa-page">
      <Header
        profileImage="" //optional
        name={`${activeUser?.firstName} ${activeUser?.lastName}`}
        role={activeUser?.role}
        onNotificationClick={() => alert(t("Prikaz notifikacija"))}
        onLogoutClick={() => {
          removeActiveUser();
          navigate(`/login`);
        }}
      />
      <div className="rwa-page-content">
        <div className="rwa-main-menu-wrapper">
          <MainMenu menuItemList={state.mainMenu} />
        </div>
        <div className="rwa-content-wrapper">
          <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => {
              // reset the state of your app so the error doesn't happen again
            }}
          >
            {p.children}
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};
